import { createApp } from 'vue'
import ArcoVue from '@arco-design/web-vue'
import '@arco-design/web-vue/dist/arco.css'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import './styles/global.less'
import { useMenuStore } from './stores/menu'
import { useUserStore } from './stores/user'
import { useTablePreferencesStore } from './stores/tablePreferences'
import { APP_TITLE } from './constants/app'

document.title = APP_TITLE

const app = createApp(App)
const pinia = createPinia()

app.use(ArcoVue)
app.use(router)
app.use(pinia)

// 应用启动时恢复菜单和权限，并拉取最新用户角色（避免改角色后必须重新登录）
const menuStore = useMenuStore()
if (localStorage.getItem('token')) {
  menuStore.restoreFromStorage()
  const tablePreferencesStore = useTablePreferencesStore()
  tablePreferencesStore.restoreFromStorage()
  const userStore = useUserStore()
  void userStore.refreshUserInfo(true)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      void userStore.refreshUserInfo()
    }
  })
}

app.mount('#app')
